import { Decimal } from 'decimal.js';

import { BasketProduct, Basket } from 'src/store/slices/basket-slice';
import {
    SelectedPrice,
    LegalRepresentative,
    Options,
    Tracking,
} from 'src/store/types/basket-types';

import {
    roomData,
    initialStudentNumber,
    totalPaymentData,
} from '../../features/booking-summary/constants';

// Constants for fetching booking details
export const DEMO_ROOM_NAME = 'RH-204';
export const DEMO_ACADEMIC_YEAR = '2024 / 25';

// Constants for magic strings and numbers
const CURRENCY_GBP = 'GBP';
const INSTALMENT_TYPE = 'Annual';
const PHONE_CODE_UK = '+44';
const VENDOR_STUDENT_BOOKING = 'studentbookingvendor';
const DEPOSIT_AMOUNT = new Decimal(350.78);
const FEE_AMOUNT = new Decimal(100.13);
const NON_DISCOUNTED_AMOUNT = new Decimal(100.19);
const PRICE = new Decimal(483.19);
const ADVANCE_PAYMENT_WEEKS = 0;
const INITIAL_STUDENT_NUMBER = initialStudentNumber;

// Constant for unique identifiers
const PRODUCT_ID = '09990e15-f6b6-4476-a826-335468b7c554';
const BUILDING_ID = 'a011p00001NjtGTAAZ';
const DEVELOPMENT_ID = '09990e15-f6b6-4476-a826-335468b7c901';
const PAYMENT_PLAN_ID = 'a033L00000tTxfhQAC';

// Constants for tracking
const LEAD_SOURCE_DIRECT = 'direct';
const LEAD_MEDIUM = '-';
const LEAD_CAMPAIGN = '-';

export const productData: BasketProduct = {
    id: PRODUCT_ID,
    room_code: roomData.address,
    academic_year: roomData.date,
    building_id: BUILDING_ID,
    development_id: DEVELOPMENT_ID,
    price: PRICE,
    currency: CURRENCY_GBP,
    deposit: DEPOSIT_AMOUNT,
    advance_payment_weeks: ADVANCE_PAYMENT_WEEKS,
    deposit_prepaid: true,
    selected_students: INITIAL_STUDENT_NUMBER,
    term: `38 Weeks`,
    beds: parseInt(roomData.bedCount.split(' ')[0], 10),
    payment_plan_id: PAYMENT_PLAN_ID,
    instalment_type: INSTALMENT_TYPE,
    cbl: false,
    stl: false,
    occupants: [],
    selected_price: {
        fee: FEE_AMOUNT,
        today: new Decimal(totalPaymentData.amount),
        non_discounted: NON_DISCOUNTED_AMOUNT,
    } as SelectedPrice,
    legal_representative: {
        first_name: 'Jane',
        last_name: 'Doe',
        email: 'jane.doe@unknown.com',
        number: '3111234562',
        phone_code: PHONE_CODE_UK,
    } as LegalRepresentative,
    promotion_id: null,
};

export const basketData: Partial<Basket> = {
    user: null,
    products: [productData],
    options: {
        rebooker: false,
    } as Options,
    tracking: {
        lead_source: LEAD_SOURCE_DIRECT,
        lead_medium: LEAD_MEDIUM,
        lead_campaign: LEAD_CAMPAIGN,
    } as Tracking,
    vendor: VENDOR_STUDENT_BOOKING,
    room_mates: null,
    licence_agreement_signed_at: null,
    booking_terms_signed_at: null,
    created_date: null,
    updated_date: null,
};
